(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-hl-announcement][data-mode="slider"]').forEach(function (root) {
      var slides = root.querySelectorAll('[data-hl-announcement-slide]');
      var dots = root.querySelectorAll('[data-hl-announcement-dot]');
      var prevBtn = root.querySelector('[data-hl-announcement-prev]');
      var nextBtn = root.querySelector('[data-hl-announcement-next]');
      if (!slides.length) return;
      if (slides.length === 1) return;

      var index = 0;
      var autoplaySec = parseInt(root.getAttribute('data-autoplay'), 10) || 4;
      var pauseOnHover = root.getAttribute('data-pause-on-hover') === 'true';
      var timer = null;

      function go(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, idx) {
          s.classList.toggle('is-active', idx === index);
          if (idx === index) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        });
        dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === index); });
      }
      function next() { go(index + 1); }
      function prev() { go(index - 1); }
      function start() { if (autoplaySec > 0) timer = setInterval(next, autoplaySec * 1000); }
      function stop() { if (timer) clearInterval(timer); timer = null; }

      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); stop(); start(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); stop(); start(); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-hl-announcement-dot'), 10) || 0); stop(); start(); });
      });
      if (pauseOnHover) {
        root.addEventListener('mouseenter', stop);
        root.addEventListener('mouseleave', start);
      }
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-hl-ba]').forEach(function (frame) {
      var range = frame.querySelector('[data-hl-ba-range]');
      var before = frame.querySelector('[data-hl-ba-before]');
      var divider = frame.querySelector('[data-hl-ba-divider]');
      if (!before && !divider) return;
      function set(v) {
        v = Math.max(0, Math.min(100, v));
        if (before) before.style.clipPath = 'inset(0 ' + (100 - v) + '% 0 0)';
        if (divider) divider.style.left = v + '%';
      }
      if (range) {
        set(parseFloat(range.value));
        range.addEventListener('input', function () { set(parseFloat(range.value)); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-posts"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var roots = document.querySelectorAll('.hl-blog-posts');
    if (!roots.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    roots.forEach(function (r) { r.querySelectorAll('.hl-reveal').forEach(function (c) { io.observe(c); }); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRecs(root) {
      if (!root || root.dataset.hlCrInit === '1') return;
      var isSlider = root.classList.contains('hl-cart-recs--layout-slider');
      var isForceMobile = root.classList.contains('hl-cart-recs--force-slider-m');
      if (!isSlider && !isForceMobile) return;
      var track = root.querySelector('[data-hl-cart-recs-track]');
      if (!track) return;
      var loop = root.getAttribute('data-hl-cart-recs-loop') !== 'false';

      function slides() {
        return Array.prototype.filter.call(track.children, function (el) {
          return el.nodeType === 1;
        });
      }
      if (slides().length < 2) return;

      function slideStep() {
        // Step by one slide width (= card width + gap).
        var s = slides();
        if (!s[0] || !s[1]) {
          return s[0] ? s[0].getBoundingClientRect().width : track.clientWidth;
        }
        return s[1].getBoundingClientRect().left - s[0].getBoundingClientRect().left;
      }
      function current() {
        var step = slideStep();
        return step ? Math.round(track.scrollLeft / step) : 0;
      }
      function update(i) {
        root.querySelectorAll('[data-hl-cart-recs-dot]').forEach(function (d, idx) {
          d.classList.toggle('is-active', idx === i);
        });
      }
      function go(i) {
        var n = slides().length;
        if (n < 1) return;
        if (i < 0) i = loop ? n - 1 : 0;
        if (i >= n) i = loop ? 0 : n - 1;
        var step = slideStep();
        if (track.scrollTo) track.scrollTo({ left: i * step, behavior: 'smooth' });
        else track.scrollLeft = i * step;
        update(i);
      }

      root.addEventListener('click', function (e) {
        var dot = e.target.closest('[data-hl-cart-recs-dot]');
        if (dot && root.contains(dot)) {
          go(parseInt(dot.getAttribute('data-hl-cart-recs-dot'), 10) || 0);
          return;
        }
        if (e.target.closest('[data-hl-cart-recs-prev]')) { go(current() - 1); return; }
        if (e.target.closest('[data-hl-cart-recs-next]')) { go(current() + 1); return; }
      });

      track.addEventListener('scroll', function () { update(current()); }, { passive: true });

      update(0);
      root.dataset.hlCrInit = '1';
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.hl-cart-recs--layout-slider, .hl-cart-recs--force-slider-m').forEach(initRecs);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load',   function (e) { initAll(e.target); });
    document.addEventListener('shopify:section:select', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Show-more / Show less inside sidebar filter groups */
    document.querySelectorAll('[data-hl-filter-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.hl-grid__sidebar-group');
        if (!group) return;
        var expanded = group.classList.toggle('is-expanded');
        btn.textContent = expanded
          ? (btn.getAttribute('data-expanded-label')  || 'Show less')
          : (btn.getAttribute('data-collapsed-label') || 'Show more');
      });
    });

    /* Live-search inside long filter lists */
    document.querySelectorAll('[data-hl-filter-search]').forEach(function (input) {
      var group = input.closest('.hl-grid__sidebar-group');
      if (!group) return;
      var items = group.querySelectorAll('[data-hl-filter-item]');
      input.addEventListener('input', function () {
        var q = (input.value || '').trim().toLowerCase();
        var anyHidden = false;
        items.forEach(function (item) {
          var label = item.getAttribute('data-label') || '';
          var match = !q || label.indexOf(q) !== -1;
          item.classList.toggle('is-hidden', !match);
          if (!match) anyHidden = true;
        });
        /* When searching, force-show overflowed items too */
        group.classList.toggle('is-expanded', !!q && anyHidden);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.hl-tabs').forEach(function (root) {
      var tabs   = root.querySelectorAll('[data-hl-tabs-tab]');
      var panels = root.querySelectorAll('[data-hl-tabs-panel]');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = t.getAttribute('data-hl-tabs-tab');
          tabs.forEach(function (x) {
            x.classList.toggle('is-active', x.getAttribute('data-hl-tabs-tab') === i);
            x.setAttribute('aria-selected', x.getAttribute('data-hl-tabs-tab') === i ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            var match = p.getAttribute('data-hl-tabs-panel') === i;
            p.classList.toggle('is-active', match);
            if (match) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-toolbar"] && !Shopify.designMode) return;
  try {
    
  // Sort: clicking an option navigates with sort_by set.
  document.addEventListener('click', function (e) {
    var opt = e.target.closest('.hl-toolbar__sort-option');
    if (opt) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', opt.dataset.sortValue);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
      return;
    }
    // Filter close button / backdrop.
    var closeTrigger = e.target.closest('[data-filter-close]');
    if (closeTrigger) {
      var det = closeTrigger.closest('.hl-toolbar__filter');
      if (det) det.removeAttribute('open');
      return;
    }
    // Close horizontal filter when clicking outside; drawer requires explicit close.
    document.querySelectorAll('.hl-toolbar__filter[open]').forEach(function (det) {
      var mode = det.getAttribute('data-filter-mode');
      if (mode === 'drawer') return;
      if (!det.contains(e.target)) det.removeAttribute('open');
    });
    // Close any open sort dropdown when clicking outside.
    document.querySelectorAll('details.hl-toolbar__sort[open]').forEach(function (det) {
      if (!det.contains(e.target)) det.removeAttribute('open');
    });
  });

  // Filter form: drop empty number fields so we don't generate empty params.
  document.querySelectorAll('.hl-toolbar__filter-panel').forEach(function (form) {
    form.addEventListener('submit', function () {
      Array.from(form.querySelectorAll('input')).forEach(function (input) {
        if (input.type === 'number' && input.value === '') input.disabled = true;
      });
    });
  });

  // Esc closes the filter panel and the sort dropdown.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.hl-toolbar__filter[open], .hl-toolbar__sort[open]').forEach(function (det) {
      det.removeAttribute('open');
    });
  });

  // Lock body scroll when a filter drawer is open.
  document.querySelectorAll('.hl-toolbar__filter[data-filter-mode="drawer"]').forEach(function (det) {
    det.addEventListener('toggle', function () {
      document.body.style.overflow = det.open ? 'hidden' : '';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.hl-countdown').forEach(function (root) {
      var target = new Date(root.dataset.target).getTime();
      if (isNaN(target)) return;
      var d = root.querySelector('[data-cd-days]');
      var h = root.querySelector('[data-cd-hours]');
      var m = root.querySelector('[data-cd-minutes]');
      var s = root.querySelector('[data-cd-seconds]');

      function pad(n) { return n.toString().padStart(2, '0'); }

      function tick() {
        var now = Date.now();
        var diff = Math.max(0, target - now);
        if (diff === 0) {
          if (d) d.textContent = '00';
          if (h) h.textContent = '00';
          if (m) m.textContent = '00';
          if (s) s.textContent = '00';
          var row = root.querySelector('.hl-countdown__row');
          if (row && root.dataset.expiredText) {
            row.outerHTML = '<div class="display hl-countdown__expired">' + root.dataset.expiredText + '</div>';
          }
          return false;
        }
        var ds = Math.floor(diff / 86400000);
        var hs = Math.floor((diff % 86400000) / 3600000);
        var ms = Math.floor((diff % 3600000) / 60000);
        var ss = Math.floor((diff % 60000) / 1000);
        if (d) d.textContent = pad(ds);
        if (h) h.textContent = pad(hs);
        if (m) m.textContent = pad(ms);
        if (s) s.textContent = pad(ss);
        return true;
      }

      tick();
      var iv = setInterval(function () { if (!tick()) clearInterval(iv); }, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-hl-faqtabs]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-hl-faqtab]');
      var panels = root.querySelectorAll('[data-hl-faqpanel]');
      if (!tabs.length || !panels.length) return;
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var slug = tab.getAttribute('data-hl-faqtab');
          tabs.forEach(function (t) {
            var isActive = t === tab;
            t.classList.toggle('is-active', isActive);
            t.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            var match = p.getAttribute('data-hl-faqpanel') === slug;
            p.classList.toggle('is-active', match);
            if (match) p.removeAttribute('hidden');
            else p.setAttribute('hidden', '');
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFp(root) {
      if (!root || root.dataset.hlFpInit === '1') return;
      var variants;
      try { variants = JSON.parse(root.getAttribute('data-variants') || '[]'); }
      catch (e) { return; }
      if (!variants.length) return;

      var form = root.querySelector('.hl-fp__form');
      var idInput = root.querySelector('[data-hl-fp-id]');
      var priceEl = root.querySelector('[data-hl-fp-price]');
      var compareEl = root.querySelector('[data-hl-fp-compare]');
      var atcBtn = root.querySelector('[data-hl-fp-atc]');
      var atcLabel = root.querySelector('[data-hl-fp-atc-label]');
      var atcPrice = root.querySelector('[data-hl-fp-atc-price]');
      var qtyInput = root.querySelector('[data-hl-fp-qty]');
      var qtyMinus = root.querySelector('[data-hl-fp-qty-minus]');
      var qtyPlus = root.querySelector('[data-hl-fp-qty-plus]');
      var mainImg = root.querySelector('.hl-fp__image img');
      var thumbButtons = root.querySelectorAll('.hl-fp__thumb');

      // Build current selection from active chips per option
      function currentSelection() {
        var sel = [];
        root.querySelectorAll('[data-hl-fp-option]').forEach(function (opt) {
          var active = opt.querySelector('.hl-fp__chip.is-active');
          sel.push(active ? active.getAttribute('data-value') : '');
        });
        return sel;
      }

      function findVariant(sel) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var match = true;
          for (var j = 0; j < sel.length; j++) {
            if (v.options[j] !== sel[j]) { match = false; break; }
          }
          if (match) return v;
        }
        return null;
      }

      function updateUi() {
        var sel = currentSelection();
        var v = findVariant(sel);
        if (!v) return;

        // Update hidden ID
        if (idInput) idInput.value = v.id;

        // Update main gallery image if the variant has one
        if (mainImg && v.featured_image) {
          // Build srcset from the same image at multiple widths
          var base = v.featured_image.split('?')[0];
          var qs = v.featured_image.indexOf('?') > -1 ? '&' : '?';
          // Most Shopify image URLs already include width param — use as-is for src, regen srcset
          mainImg.src = v.featured_image;
          // Try to update srcset by swapping any width=XXX param to multiple widths
          var widthMatch = /([?&])width=\d+/;
          if (widthMatch.test(v.featured_image)) {
            mainImg.srcset = [500, 900, 1400].map(function (w) {
              return v.featured_image.replace(widthMatch, '$1width=' + w) + ' ' + w + 'w';
            }).join(', ');
          }
          mainImg.alt = v.title || mainImg.alt;
          // If thumbnails exist, mark the matching one active
          if (thumbButtons && thumbButtons.length) {
            thumbButtons.forEach(function (t) {
              var thumbSrc = (t.querySelector('img') || {}).src || '';
              var thumbBase = thumbSrc.split('?')[0];
              var variantBase = v.featured_image.split('?')[0];
              if (thumbBase && variantBase && thumbBase.indexOf(variantBase.split('/').pop().split('.')[0]) > -1) {
                thumbButtons.forEach(function (tt) { tt.classList.remove('is-active'); });
                t.classList.add('is-active');
              }
            });
          }
        }

        // Update price
        if (priceEl) priceEl.textContent = v.price_formatted;
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compareEl.textContent = v.compare_at_price_formatted;
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }

        // Update ATC button
        if (atcBtn) {
          if (v.available) {
            atcBtn.disabled = false;
            if (atcLabel && !atcPrice) {
              // No inline-price span — just refresh label without overwriting price span
              // (price stays in atc-price if present)
            }
            if (atcPrice) atcPrice.textContent = v.price_formatted;
          } else {
            atcBtn.disabled = true;
            if (atcLabel) atcLabel.textContent = root.getAttribute('data-soldout-label') || 'Sold out';
          }
        }

        // Update visible "selected value" labels per option
        root.querySelectorAll('[data-hl-fp-option]').forEach(function (opt, idx) {
          var label = opt.querySelector('[data-hl-fp-option-value]');
          if (label) label.textContent = sel[idx] || '';
        });

        // Disable unavailable values (basic — could be smarter)
        root.querySelectorAll('[data-hl-fp-option]').forEach(function (opt, idx) {
          opt.querySelectorAll('[data-hl-fp-value]').forEach(function (chip) {
            var candidate = sel.slice();
            candidate[idx] = chip.getAttribute('data-value');
            var match = findVariant(candidate);
            chip.toggleAttribute('disabled', !match || !match.available);
          });
        });
      }

      // Click on a chip → set as active in its option and refresh UI
      root.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-hl-fp-value]');
        if (chip && root.contains(chip)) {
          e.preventDefault();
          var optWrap = chip.closest('[data-hl-fp-option]');
          if (!optWrap) return;
          optWrap.querySelectorAll('.hl-fp__chip').forEach(function (c) {
            c.classList.remove('is-active');
            c.setAttribute('aria-pressed', 'false');
          });
          chip.classList.add('is-active');
          chip.setAttribute('aria-pressed', 'true');
          updateUi();
          return;
        }
      });

      // Quantity buttons — respect min/max from input attributes
      function clampQty() {
        if (!qtyInput) return;
        var min = parseInt(qtyInput.getAttribute('min'), 10) || 1;
        var max = parseInt(qtyInput.getAttribute('max'), 10) || 0; // 0 = no max
        var n = parseInt(qtyInput.value, 10);
        if (isNaN(n) || n < min) n = min;
        if (max > 0 && n > max) n = max;
        qtyInput.value = n;
        if (qtyMinus) qtyMinus.toggleAttribute('disabled', n <= min);
        if (qtyPlus  && max > 0) qtyPlus.toggleAttribute('disabled', n >= max);
      }
      if (qtyMinus) qtyMinus.addEventListener('click', function () {
        var n = parseInt(qtyInput.value, 10) - 1;
        qtyInput.value = n;
        clampQty();
      });
      if (qtyPlus) qtyPlus.addEventListener('click', function () {
        var n = parseInt(qtyInput.value, 10) + 1;
        qtyInput.value = n;
        clampQty();
      });
      if (qtyInput) {
        qtyInput.addEventListener('input', clampQty);
        qtyInput.addEventListener('blur', clampQty);
      }
      clampQty();

      updateUi();

      // Thumbnail → main image swap + slider arrows
      var sectionRoot = root.closest('.hl-fp') || root.parentElement;
      var galleryRoot = sectionRoot ? sectionRoot.querySelector('[data-hl-fp-gallery]') : null;
      if (galleryRoot) {
        var galleryMainImg = galleryRoot.querySelector('[data-hl-fp-main-img]');
        var thumbs = galleryRoot.querySelectorAll('[data-hl-fp-thumb]');
        var thumbStrip = galleryRoot.querySelector('[data-hl-fp-thumbs]');
        var thumbWrap = galleryRoot.querySelector('[data-hl-fp-thumbs-wrap]');
        var prevArrow = galleryRoot.querySelector('[data-hl-fp-thumb-prev]');
        var nextArrow = galleryRoot.querySelector('[data-hl-fp-thumb-next]');

        thumbs.forEach(function (t) {
          t.addEventListener('click', function () {
            if (!galleryMainImg) return;
            var full = t.getAttribute('data-full');
            var srcset = t.getAttribute('data-srcset');
            if (full) {
              galleryMainImg.style.opacity = '0';
              setTimeout(function () {
                galleryMainImg.src = full;
                if (srcset) galleryMainImg.srcset = srcset;
                galleryMainImg.style.opacity = '';
              }, 120);
            }
            thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
          });
        });

        // Slider behavior: show arrows only when overflow exists, scroll by step,
        // disable arrows at the start/end of the strip.
        if (thumbStrip && thumbWrap) {
          var isVertical = thumbWrap.className.indexOf('--pos-left') !== -1 ||
                           thumbWrap.className.indexOf('--pos-right') !== -1;

          function needsScroll() {
            return isVertical
              ? thumbStrip.scrollHeight > thumbStrip.clientHeight + 2
              : thumbStrip.scrollWidth > thumbStrip.clientWidth + 2;
          }
          var arrowMode = (thumbWrap.className.match(/--arrows-(\w+)/) || [])[1] || 'hover';
          function updateArrows() {
            var overflow = needsScroll();
            // "hidden" mode never shows arrows
            if (arrowMode === 'hidden') {
              if (prevArrow) prevArrow.hidden = true;
              if (nextArrow) nextArrow.hidden = true;
              return;
            }
            // "always" + "hover" both rely on overflow to even render the arrow markup;
            // CSS handles visibility differences for hover-only mode.
            if (prevArrow) prevArrow.hidden = !overflow;
            if (nextArrow) nextArrow.hidden = !overflow;
            if (!overflow) return;
            var atStart, atEnd;
            if (isVertical) {
              atStart = thumbStrip.scrollTop <= 2;
              atEnd = thumbStrip.scrollTop + thumbStrip.clientHeight >= thumbStrip.scrollHeight - 2;
            } else {
              atStart = thumbStrip.scrollLeft <= 2;
              atEnd = thumbStrip.scrollLeft + thumbStrip.clientWidth >= thumbStrip.scrollWidth - 2;
            }
            if (prevArrow) prevArrow.toggleAttribute('disabled', atStart);
            if (nextArrow) nextArrow.toggleAttribute('disabled', atEnd);
          }
          function scrollByOne(dir) {
            var first = thumbStrip.querySelector('.hl-fp__thumb');
            if (!first) return;
            if (isVertical) {
              var step = first.getBoundingClientRect().height + 8;
              thumbStrip.scrollBy({ top: dir * step, behavior: 'smooth' });
            } else {
              var stepX = first.getBoundingClientRect().width + 8;
              thumbStrip.scrollBy({ left: dir * stepX, behavior: 'smooth' });
            }
          }

          if (prevArrow) prevArrow.addEventListener('click', function () { scrollByOne(-1); });
          if (nextArrow) nextArrow.addEventListener('click', function () { scrollByOne(1); });
          thumbStrip.addEventListener('scroll', updateArrows, { passive: true });
          window.addEventListener('resize', updateArrows);
          // Run once on init + once after images load (sizes may change)
          updateArrows();
          setTimeout(updateArrows, 300);
          setTimeout(updateArrows, 1200);
        }
      }

      root.dataset.hlFpInit = '1';
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-hl-fp-purchase]').forEach(initFp);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else { initAll(); }
    document.addEventListener('shopify:section:load',   function (e) { initAll(e.target); });
    document.addEventListener('shopify:section:select', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    function bindPicker(root, opts) {
      if (root._hlLocaleBound) return;
      root._hlLocaleBound = true;
      var trigger = root.querySelector(opts.toggle);
      var panel = root.querySelector(opts.panel);
      var items = root.querySelectorAll(opts.item);
      var search = opts.search ? root.querySelector(opts.search) : null;
      var emptyEl = opts.empty ? root.querySelector(opts.empty) : null;
      var form = root.closest('form');
      var input = form ? form.querySelector(opts.input) : null;
      if (!trigger || !panel || !items.length || !form || !input) return;

      function isMobile() { return window.matchMedia('(max-width: 767px)').matches; }
      function open() {
        document.querySelectorAll('.hl-footer__locale.is-open').forEach(function (other) {
          if (other !== root) other.classList.remove('is-open');
        });
        root.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        if (isMobile()) {
          document.body.style.overflow = 'hidden';
        }
        if (search) {
          search.value = '';
          items.forEach(function (i) { i.style.display = ''; });
          if (emptyEl) emptyEl.hidden = true;
          // Don't auto-focus on mobile — would force the keyboard up immediately
          if (!isMobile()) setTimeout(function () { search.focus(); }, 60);
        }
        var active = root.querySelector('[data-active]');
        if (active) active.scrollIntoView({ block: 'nearest' });
      }
      function close() {
        root.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        // Always restore scroll regardless of viewport
        if (!document.querySelector('.hl-footer__locale.is-open')) {
          document.body.style.overflow = '';
        }
      }
      // Tap outside the picker (or on the dimmed backdrop) closes it
      document.addEventListener('click', function (e) {
        if (!root.classList.contains('is-open')) return;
        if (!root.contains(e.target)) close();
      });

      if (search) {
        search.addEventListener('input', function () {
          var q = search.value.trim().toLowerCase();
          var visible = 0;
          items.forEach(function (item) {
            var name = item.dataset.hlCountryName || item.textContent.toLowerCase();
            var hit = !q || name.indexOf(q) !== -1;
            item.style.display = hit ? '' : 'none';
            if (hit) visible++;
          });
          if (emptyEl) emptyEl.hidden = visible > 0;
        });
        search.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') { close(); trigger.focus(); }
        });
      }

    }

    document.querySelectorAll('[data-hl-locale]').forEach(function (root) {
      bindPicker(root, {
        toggle: '[data-hl-locale-toggle]',
        panel: '[data-hl-locale-panel]',
        item: '[data-hl-country]',
        search: '[data-hl-locale-search]',
        empty: '[data-hl-locale-empty]',
        input: '[data-hl-country-input]',
        dataset: 'hlCountry'
      });
    });
    document.querySelectorAll('[data-hl-language-root]').forEach(function (root) {
      bindPicker(root, {
        toggle: '[data-hl-language-toggle]',
        panel: '[data-hl-language-panel]',
        item: '[data-hl-language][role="option"]',
        input: '[data-hl-locale-input]',
        dataset: 'hlLanguage'
      });
    });

    // Close on outside click and Escape.
    document.addEventListener('click', function (e) {
      document.querySelectorAll('.hl-footer__locale.is-open').forEach(function (root) {
        if (!root.contains(e.target)) {
          root.classList.remove('is-open');
          var t = root.querySelector('.hl-footer__locale-trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.hl-footer__locale.is-open').forEach(function (root) {
        root.classList.remove('is-open');
        var t = root.querySelector('.hl-footer__locale-trigger');
        if (t) { t.setAttribute('aria-expanded', 'false'); t.focus(); }
      });
    });

    /* Link-column accordion: server renders <details open> so desktop + no-JS mobile show the list expanded.
       On mobile (when the parent .hl-footer--collapse-mobile is set), close them so the user gets a real accordion. */
    function applyMobileAccordion() {
      var root = document.querySelector('.hl-footer--collapse-mobile');
      if (!root) return;
      var mobile = window.matchMedia('(max-width: 767px)').matches;
      root.querySelectorAll('.hl-footer__col').forEach(function (det) {
        if (mobile) det.removeAttribute('open');
        else        det.setAttribute('open', '');
      });
    }
    applyMobileAccordion();
    window.addEventListener('resize', applyMobileAccordion);
    document.addEventListener('shopify:section:load', applyMobileAccordion);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-hl-gstrip]').forEach(function (root) {
      if (root.dataset.hlGstripInit === '1') return;
      var track = root.querySelector('[data-hl-gstrip-track]');
      if (!track) return;
      var prev = root.querySelector('[data-hl-gstrip-prev]');
      var next = root.querySelector('[data-hl-gstrip-next]');
      function scrollByCells(dir) {
        var first = track.querySelector('.hl-gstrip__cell');
        if (!first) return;
        var step = first.getBoundingClientRect().width + 8;
        track.scrollBy({ left: dir * step * 2, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { scrollByCells(-1); });
      if (next) next.addEventListener('click', function () { scrollByCells(1); });
      root.dataset.hlGstripInit = '1';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-hl-gallery][data-lightbox="true"]').forEach(function (root) {
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-hl-gal-item]'));
      if (!items.length) return;
      var lb = root.querySelector('[data-hl-gal-lightbox]');
      if (!lb) return;
      var img = lb.querySelector('[data-hl-gal-lb-img]');
      var cap = lb.querySelector('[data-hl-gal-lb-cap]');
      var counter = lb.querySelector('[data-hl-gal-lb-counter]');
      var prev = lb.querySelector('[data-hl-gal-lb-prev]');
      var next = lb.querySelector('[data-hl-gal-lb-next]');
      var current = 0;

      function show(i) {
        if (i < 0) i = items.length - 1;
        if (i >= items.length) i = 0;
        current = i;
        var el = items[i];
        var src = el.getAttribute('data-src');
        var captionTxt = el.getAttribute('data-caption') || '';
        var tag = el.getAttribute('data-tag') || '';
        if (img && src) img.src = src;
        if (img) img.alt = captionTxt;
        if (cap) {
          var html = '';
          if (tag) html += '<span class="hl-gal__lb-tag">' + tag + '</span>';
          if (captionTxt) html += captionTxt;
          cap.innerHTML = html;
        }
        if (counter) counter.textContent = (i + 1) + ' / ' + items.length;
      }
      function open(i) {
        show(i);
        lb.removeAttribute('hidden');
        // eslint-disable-next-line no-unused-expressions
        lb.offsetHeight;
        lb.classList.add('is-open');
        lb.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
      function close() {
        lb.classList.remove('is-open');
        lb.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        setTimeout(function () { lb.setAttribute('hidden', ''); }, 260);
      }

      // Click handlers on each thumb / zoom button
      items.forEach(function (it, idx) {
        var zoomBtn = it.querySelector('[data-hl-gal-zoom]');
        if (zoomBtn) {
          zoomBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            open(idx);
          });
        }
        // Whole cell click also opens lightbox unless it's an <a> with a real link
        if (it.tagName !== 'A') {
          it.addEventListener('click', function () { open(idx); });
          it.style.cursor = 'pointer';
        }
      });

      lb.querySelectorAll('[data-hl-gal-lb-close]').forEach(function (el) {
        el.addEventListener('click', close);
      });
      if (prev) prev.addEventListener('click', function () { show(current - 1); });
      if (next) next.addEventListener('click', function () { show(current + 1); });

      // Keyboard nav
      document.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('is-open')) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowLeft') show(current - 1);
        else if (e.key === 'ArrowRight') show(current + 1);
      });

      // Swipe on touch
      var touchStartX = 0;
      lb.addEventListener('touchstart', function (e) { touchStartX = e.changedTouches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 60) show(current + (dx < 0 ? 1 : -1));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    // Pin-on-scroll: when the header has .hl-header--pinnable, watch the
    // window scroll. Once scrollY passes the threshold (from
    // data-pin-threshold, default 50px), add .is-pinned which switches the
    // header to position: fixed via CSS. position: fixed always works
    // regardless of ancestor styling — no CSS specificity wars.
    var header = null;
    var threshold = 50;
    var pinned = false;
    function bindHeader() {
      header = document.querySelector('.hl-header');
      if (header) {
        threshold = parseInt(header.getAttribute('data-pin-threshold'), 10) || 50;
      }
    }
    function onScroll() {
      if (!header || !header.isConnected) bindHeader();
      if (!header || !header.classList.contains('hl-header--pinnable')) return;
      var shouldPin = window.scrollY > threshold;
      if (shouldPin && !pinned) {
        header.classList.add('is-pinned');
        pinned = true;
      } else if (!shouldPin && pinned) {
        header.classList.remove('is-pinned');
        pinned = false;
      }
    }
    bindHeader();
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('.hl-header')) {
        pinned = false;
        bindHeader();
        onScroll();
      }
    });
    onScroll();

    /* Mobile drawer
       Open/close/Escape/overlay-click are all owned by hemline.js via
       document-level delegation on [data-mm-open] / [data-mm-close]. The
       overlay carries data-mm-close so a click on it routes through the
       same closeEl() path. Keeping a second handler set here would cause
       dual class-name state (.open vs .is-open, .menu-open vs
       .mobile-menu-locked) and stale-state bugs. */
    /* Close drawer when any nav link inside it is followed. hemline.js does
       not auto-close on in-drawer link clicks, so this lives here.
       Uses document-level delegation so it survives shopify:section:load
       swaps that replace the #mobile-menu DOM node. */
    document.addEventListener('click', function (e) {
      var link = e.target.closest('#mobile-menu a[href]');
      if (!link) return;
      var menu = document.getElementById('mobile-menu');
      var body = document.body;
      setTimeout(function () {
        if (menu) menu.classList.remove('open');
        body.classList.remove('menu-open');
      }, 50);
    });
    /* Editor: ensure drawer starts closed when the section reloads */
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('#mobile-menu')) {
        var d = document.getElementById('mobile-menu');
        if (d) {
          d.classList.remove('open');
          d.setAttribute('aria-hidden', 'true');
        }
        document.body.classList.remove('menu-open');
      }
    });

    /* Desktop header locale / language picker:
       The footer/drawer JS already binds to every [data-hl-locale] and
       [data-hl-language] in the document. We reuse the same data-attributes
       on the header markup so a single tested implementation drives all
       three placements (footer / drawer / header). No JS needed here. */
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var grids = document.querySelectorAll('.hl-igrid--reveal');
    if (!grids.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    grids.forEach(function (g) {
      g.querySelectorAll('.hl-igrid__cell').forEach(function (c, i) {
        c.style.transitionDelay = (i % 6) * 60 + 'ms';
        io.observe(c);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-hotspots"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-hl-hs-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var hotspot = btn.closest('.hl-hs__hotspot');
        if (!hotspot) return;
        var isOpen = hotspot.classList.contains('is-open');
        // Close all other hotspots in the same section
        var section = hotspot.closest('.hl-hotspots');
        if (section) section.querySelectorAll('.hl-hs__hotspot.is-open').forEach(function (h) {
          h.classList.remove('is-open');
          var b = h.querySelector('[data-hl-hs-toggle]');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          hotspot.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
    // Close on outside click
    document.addEventListener('click', function (e) {
      if (e.target.closest('.hl-hs__hotspot')) return;
      document.querySelectorAll('.hl-hs__hotspot.is-open').forEach(function (h) {
        h.classList.remove('is-open');
        var b = h.querySelector('[data-hl-hs-toggle]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.hl-look__spot').forEach(function (spot) {
      var btn = spot.querySelector('.hl-look__dot');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelectorAll('.hl-look__spot.is-open').forEach(function (s) {
          if (s !== spot) s.classList.remove('is-open');
        });
        spot.classList.toggle('is-open');
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.hl-look__spot')) {
        document.querySelectorAll('.hl-look__spot.is-open').forEach(function (s) { s.classList.remove('is-open'); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-block"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('form[data-hl-newsletter]').forEach(function (form) {
      if (form.dataset.bound === '1') return;
      form.dataset.bound = '1';
      var feedback = form.querySelector('[data-hl-newsletter-feedback]');
      var btn = form.querySelector('[data-hl-newsletter-submit]');
      var label = form.querySelector('[data-hl-newsletter-label]');
      var origLabel = label ? label.innerHTML : '';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (btn) btn.disabled = true;
        if (label) label.textContent = '…';
        if (feedback) { feedback.hidden = true; feedback.textContent = ''; feedback.className = 'hl-newsletter__feedback'; }
        var action = form.getAttribute('action') || (window.location.pathname + '?form_type=customer');
        fetch(action, {
          method: 'POST',
          body: new FormData(form),
          headers: { 'Accept': 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin',
          redirect: 'follow'
        })
          .then(function (r) { return r.text().then(function (t) { return { ok: r.ok, text: t }; }); })
          .then(function (res) {
            var text = res.text || '';
            var hasFormError =
              /Email\s+(is|has\s+already|cannot|must)\b/i.test(text) ||
              /Please\s+enter\s+a\s+valid\s+email/i.test(text) ||
              /Could not create customer/i.test(text);
            if (res.ok && !hasFormError) {
              if (feedback) {
                feedback.hidden = false;
                feedback.textContent = form.getAttribute('data-success') || 'Welcome. Look out for a quiet hello soon.';
                feedback.className = 'hl-newsletter__feedback is-success';
              }
              var emailField = form.querySelector('input[type="email"]');
              if (emailField) emailField.value = '';
            } else if (feedback) {
              feedback.hidden = false;
              feedback.textContent = hasFormError
                ? (btn && btn.getAttribute('data-error-invalid')) || 'That email looks invalid or is already subscribed.'
                : (btn && btn.getAttribute('data-error-generic')) || 'Something went wrong. Please try again.';
              feedback.className = 'hl-newsletter__feedback is-error';
            }
          })
          .catch(function () {
            if (feedback) {
              feedback.hidden = false;
              feedback.textContent = (btn && btn.getAttribute('data-error-network')) || 'Network error. Please try again.';
              feedback.className = 'hl-newsletter__feedback is-error';
            }
          })
          .finally(function () {
            if (btn) btn.disabled = false;
            if (label) label.innerHTML = origLabel;
          });
      });
      var successMsg = form.querySelector('.hl-newsletter__feedback.is-success');
      if (successMsg) form.setAttribute('data-success', successMsg.textContent.trim());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-hl-newsletter-popup]').forEach(function (root) {
      var key = 'hl-nlpop-dismissed';
      var sessionKey = 'hl-nlpop-shown-session';
      var frequencyDays = parseInt(root.getAttribute('data-frequency-days'), 10) || 14;
      var showOnce = root.getAttribute('data-show-once') === 'true';
      var trigger = root.getAttribute('data-trigger') || 'delay';
      var delay = parseInt(root.getAttribute('data-delay'), 10) || 6;
      var scrollPct = parseInt(root.getAttribute('data-scroll-pct'), 10) || 40;

      function isDismissed() {
        if (showOnce && sessionStorage.getItem(sessionKey)) return true;
        var raw = localStorage.getItem(key);
        if (!raw) return false;
        var ts = parseInt(raw, 10);
        if (isNaN(ts)) return false;
        var age = (Date.now() - ts) / (1000 * 60 * 60 * 24);
        return age < frequencyDays;
      }
      function markDismissed() {
        try {
          localStorage.setItem(key, String(Date.now()));
          if (showOnce) sessionStorage.setItem(sessionKey, '1');
        } catch (e) {}
      }
      function open() {
        if (root.classList.contains('is-open')) return;
        root.removeAttribute('hidden');
        // Force a reflow so the transition runs.
        // eslint-disable-next-line no-unused-expressions
        root.offsetHeight;
        root.classList.add('is-open');
        root.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
      function close() {
        root.classList.remove('is-open');
        root.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (root.getAttribute('data-test-mode') !== 'true') markDismissed();
        setTimeout(function () { root.setAttribute('hidden', ''); }, 320);
      }

      root.querySelectorAll('[data-hl-nlpop-close]').forEach(function (el) {
        el.addEventListener('click', close);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && root.classList.contains('is-open')) close();
      });

      var form = root.querySelector('form.hl-nlpop__form');
      var feedback = root.querySelector('[data-hl-nlpop-feedback]');
      var stateForm = root.querySelector('[data-hl-nlpop-state="form"]');
      var stateSuccess = root.querySelector('[data-hl-nlpop-state="success"]');

      /* If the form posted successfully (full page reload path), show success state immediately. */
      if (root.querySelector('[data-hl-nlpop-server-success]')) {
        if (stateSuccess) {
          if (stateForm) stateForm.setAttribute('hidden', '');
          stateSuccess.removeAttribute('hidden');
          markDismissed();
        }
      }

      function showSuccessState() {
        if (stateForm) stateForm.setAttribute('hidden', '');
        if (stateSuccess) stateSuccess.removeAttribute('hidden');
      }

      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var fd = new FormData(form);
          var btn = form.querySelector('.hl-nlpop__submit');
          var btnLabel = form.querySelector('.hl-nlpop__submit-label');
          var origLabel = btnLabel ? btnLabel.textContent : '';
          var action = form.getAttribute('action') || (window.location.pathname + '?form_type=customer');
          if (btn) btn.disabled = true;
          if (btnLabel) btnLabel.textContent = '…';
          /* Shopify customer form expects a regular POST; it returns HTML on success or error.
             We fetch the same URL with the form data and parse the response text to look for
             the success marker (the [form.posted_successfully?] block fires when the
             form is processed). If the response is an HTML redirect (302), fetch follows it
             and returns the new page; in that case we still consider it a success. */
          fetch(action, {
            method: 'POST',
            body: fd,
            headers: {
              'Accept': 'text/html, application/xhtml+xml',
              'X-Requested-With': 'XMLHttpRequest'
            },
            credentials: 'same-origin',
            redirect: 'follow'
          })
            .then(function (r) {
              return r.text().then(function (text) {
                return { ok: r.ok, status: r.status, url: r.url, text: text };
              });
            })
            .then(function (res) {
              /* Detect specific Shopify customer-form error phrases. These only
                 appear in the rendered output when Shopify itself rejected the
                 submission (validation, dupe, etc.) — they won't false-positive
                 on the page's regular CSS class names or unrelated forms. */
              var text = res.text || '';
              var hasFormError =
                /Email\s+(is|has\s+already|cannot|must)\b/i.test(text) ||
                /Please\s+enter\s+a\s+valid\s+email/i.test(text) ||
                /Could not create customer/i.test(text);
              if (res.ok && !hasFormError) {
                markDismissed();
                if (stateSuccess) {
                  showSuccessState();
                } else if (feedback) {
                  feedback.hidden = false;
                  feedback.textContent = root.getAttribute('data-success-inbox-message') || 'Thanks — check your inbox.';
                  feedback.className = 'hl-nlpop__feedback is-success';
                  setTimeout(close, 1800);
                }
              } else if (feedback) {
                feedback.hidden = false;
                feedback.textContent = hasFormError
                  ? (root.getAttribute('data-error-invalid') || 'That email looks invalid or is already subscribed.')
                  : (root.getAttribute('data-error-generic') || 'Something went wrong. Please try again.');
                feedback.className = 'hl-nlpop__feedback is-error';
              }
            })
            .catch(function () {
              if (feedback) {
                feedback.hidden = false;
                feedback.textContent = root.getAttribute('data-error-network') || 'Network error. Please try again.';
                feedback.className = 'hl-nlpop__feedback is-error';
              }
            })
            .finally(function () {
              if (btn) btn.disabled = false;
              if (btnLabel) btnLabel.textContent = origLabel;
            });
        });
      }

      // Copy-code button on success state
      var copyBtn = root.querySelector('[data-hl-nlpop-copy]');
      var codeEl = root.querySelector('[data-hl-nlpop-code]');
      if (copyBtn && codeEl) {
        copyBtn.addEventListener('click', function () {
          var code = codeEl.textContent.trim();
          var done = function () {
            copyBtn.classList.add('is-copied');
            var label = copyBtn.querySelector('span');
            if (label) {
              var orig = label.textContent;
              label.textContent = root.getAttribute('data-copied-label') || 'Copied';
              setTimeout(function () {
                label.textContent = orig;
                copyBtn.classList.remove('is-copied');
              }, 1600);
            }
          };
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).then(done, function () {});
          } else {
            // Fallback for older browsers
            var ta = document.createElement('textarea');
            ta.value = code;
            ta.style.position = 'fixed';
            ta.style.opacity = '0';
            document.body.appendChild(ta);
            ta.select();
            try { document.execCommand('copy'); done(); } catch (e) {}
            document.body.removeChild(ta);
          }
        });
      }

      // Test mode bypasses dismissal logic, designMode skip, and frequency
      // window — useful while configuring/testing the popup. It still respects
      // the trigger setting (delay / scroll / exit) so you can validate each.
      var testMode = root.getAttribute('data-test-mode') === 'true';
      if (!testMode) {
        // Don't show in theme editor preview (would spam previews)
        if (window.Shopify && window.Shopify.designMode) return;
        if (isDismissed()) return;
      } else {
        // Helpful console hint when test mode is on.
        try { console.info('[Hemline] Newsletter popup TEST MODE active — dismissal + designMode checks bypassed.'); } catch (e) {}
      }

      if (trigger === 'scroll') {
        function onScroll() {
          var pct = window.scrollY / Math.max(1, document.body.scrollHeight - window.innerHeight) * 100;
          if (pct >= scrollPct) {
            open();
            window.removeEventListener('scroll', onScroll);
          }
        }
        window.addEventListener('scroll', onScroll, { passive: true });
      } else if (trigger === 'exit') {
        function onLeave(e) {
          if (e.clientY <= 0) {
            open();
            document.removeEventListener('mouseout', onLeave);
          }
        }
        document.addEventListener('mouseout', onLeave);
        // Mobile fallback: also use delay
        setTimeout(open, Math.max(delay, 8) * 1000);
      } else {
        setTimeout(open, delay * 1000);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["often-bought-together"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function moneyFmt(cents) {
      var sym = (window.Shopify && Shopify.currency && Shopify.currency.symbol) || '$';
      var n = cents / 100;
      return sym + n.toFixed(n % 1 === 0 ? 0 : 2);
    }

    function initObt(root) {
      if (!root || root.dataset.hlObtInit === '1') return;
      var itemsContainer = root.querySelector('[data-hl-obt-items]');
      if (!itemsContainer) return;
      var totalEl = root.querySelector('[data-hl-obt-total]');
      var addBtn = root.querySelector('[data-hl-obt-add]');
      var addLabel = root.querySelector('[data-hl-obt-add-label]');
      var loadingEl = root.querySelector('[data-hl-obt-loading]');

      function recalc() {
        var total = 0;
        var selected = 0;
        root.querySelectorAll('[data-hl-obt-item]').forEach(function (item) {
          var input = item.querySelector('input[type="checkbox"]');
          if (input && input.checked) {
            var price = parseInt(item.getAttribute('data-price'), 10) || 0;
            total += price;
            selected++;
          }
        });
        if (totalEl) totalEl.textContent = moneyFmt(total);
        if (addBtn) addBtn.disabled = selected === 0;
      }

      function bindToggles() {
        root.querySelectorAll('[data-hl-obt-toggle]').forEach(function (input) {
          if (input.dataset.bound === '1') return;
          input.addEventListener('change', recalc);
          input.dataset.bound = '1';
        });
      }

      // If no manual blocks, fetch Shopify recommendations
      if (loadingEl) {
        var url = root.getAttribute('data-recommend-url');
        if (url) {
          fetch(url + '&section_id=' + (root.closest('.shopify-section') || {}).id)
            .then(function (r) { return r.text(); })
            .then(function (html) {
              // Try Shopify's standard recommendations response (HTML fragment)
              var temp = document.createElement('div');
              temp.innerHTML = html;
              var products = temp.querySelectorAll('[data-product-id], .product-recommendations__item, .product-card, [data-handle]');
              if (!products.length) {
                // Fall back to JSON
                return fetch(url + '&section_id=&format=json').then(function (r) { return r.json(); });
              }
              return null;
            })
            .catch(function () {})
            .finally(function () {
              if (loadingEl && !root.querySelectorAll('[data-hl-obt-toggle]').length) {
                loadingEl.textContent = root.getAttribute('data-empty-message') || 'Add complementary products in the section settings to enable bundle pairing.';
              } else if (loadingEl) {
                loadingEl.remove();
              }
              bindToggles();
              recalc();
            });
        }
      }

      bindToggles();
      recalc();

      // Add-to-cart bundle action
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var items = [];
          root.querySelectorAll('[data-hl-obt-item]').forEach(function (item) {
            // Skip the anchor (current product) — the user is already on that page;
            // assume they already added it or will add it separately.
            if (item.classList.contains('hl-obt__item--anchor')) return;
            var input = item.querySelector('input[type="checkbox"]');
            if (input && input.checked) {
              items.push({ id: parseInt(item.getAttribute('data-variant-id'), 10), quantity: 1 });
            }
          });
          if (!items.length) return;
          var orig = addLabel ? addLabel.textContent : '';
          if (addLabel) addLabel.textContent = root.getAttribute('data-adding-label') || 'Adding…';
          addBtn.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          })
            .then(function (r) { return r.json(); })
            .then(function () {
              if (addLabel) addLabel.textContent = root.getAttribute('data-added-label') || 'Added ✓';
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              setTimeout(function () {
                if (addLabel) addLabel.textContent = orig;
                addBtn.disabled = false;
                recalc();
              }, 1800);
            })
            .catch(function () {
              if (addLabel) addLabel.textContent = root.getAttribute('data-error-label') || 'Try again';
              setTimeout(function () { if (addLabel) addLabel.textContent = orig; addBtn.disabled = false; }, 1800);
            });
        });
      }

      root.dataset.hlObtInit = '1';
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-hl-obt]').forEach(initObt);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else { initAll(); }
    document.addEventListener('shopify:section:load',   function (e) { initAll(e.target); });
    document.addEventListener('shopify:section:select', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-hl-pwd]');
    if (!roots.length) return;

    roots.forEach(function (root) {
      // Countdown
      var iso = root.getAttribute('data-launch');
      if (iso) {
        var target = new Date(iso).getTime();
        if (!isNaN(target)) {
          var dEl = root.querySelector('[data-d]');
          var hEl = root.querySelector('[data-h]');
          var mEl = root.querySelector('[data-m]');
          var sEl = root.querySelector('[data-s]');
          var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
          var t;
          var tick = function () {
            var diff = Math.max(0, target - Date.now());
            var s = Math.floor(diff / 1000);
            var d = Math.floor(s / 86400); s -= d * 86400;
            var h = Math.floor(s / 3600);  s -= h * 3600;
            var m = Math.floor(s / 60);    s -= m * 60;
            if (dEl) dEl.textContent = pad(d);
            if (hEl) hEl.textContent = pad(h);
            if (mEl) mEl.textContent = pad(m);
            if (sEl) sEl.textContent = pad(s);
            if (diff <= 0 && t) clearInterval(t);
          };
          tick();
          t = setInterval(tick, 1000);
        }
      }

      // Auto-focus password input when the <details> is open on load (e.g. after
      // an error) and again whenever the user expands it manually.
      var details = root.querySelector('[data-hl-pw-details]');
      if (details) {
        var input = details.querySelector('#hl-pwd-input');
        var errorBox = details.querySelector('[data-hl-pw-error]');
        if (details.open && input) {
          // If there's a server-side error, focus + select so the user can retype.
          setTimeout(function () {
            try { input.focus(); if (errorBox) input.select(); } catch (e) {}
          }, 50);
        }
        details.addEventListener('toggle', function () {
          if (details.open && input) {
            try { input.focus(); } catch (e) {}
          }
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"] && !Shopify.designMode) return;
  try {
    
  // Carousel
  function hlInitCarousel(root) {
    if (!root || root.dataset.ready === '1') return;
    var track = root.querySelector('[data-track]');
    if (!track) return;
    var slides = track.children;
    if (slides.length === 0) return;
    root.dataset.ready = '1';
    var index = 0;
    var total = slides.length;
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    var dots = root.querySelectorAll('[data-go]');
    var autoplay = parseInt(root.dataset.autoplay, 10) || 0;
    var timer = null;
    function go(i) {
      if (i < 0) i = total - 1;
      if (i >= total) i = 0;
      index = i;
      // Measure in pixels so the transform stays correct regardless of how the
      // track's own width is computed (flex children may not equal slider width
      // when CSS is mid-load or layout has shifted post-mount).
      var slide = slides[index];
      var w = (slide && slide.offsetWidth) || root.offsetWidth || 0;
      track.style.transform = 'translate3d(' + (-index * w) + 'px, 0, 0)';
      // Pre-warm adjacent slides so swiping doesn't show a blank frame.
      [index, (index + 1) % total, (index - 1 + total) % total].forEach(function (ix) {
        var img = slides[ix] && slides[ix].querySelector && slides[ix].querySelector('img');
        if (img && img.getAttribute('loading') === 'lazy') img.loading = 'eager';
      });
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === index); });
    }
    // Expose for external callers (e.g. variant change → reset to matching slide)
    root._hlGoTo = go;
    function startAutoplay() {
      if (!autoplay || total <= 1) return;
      stopAutoplay();
      timer = setInterval(function () { go(index + 1); }, autoplay);
    }
    function stopAutoplay() { if (timer) { clearInterval(timer); timer = null; } }
    root._hlStop = stopAutoplay;
    if (prev) prev.addEventListener('click', function () { go(index - 1); stopAutoplay(); });
    if (next) next.addEventListener('click', function () { go(index + 1); stopAutoplay(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.dataset.go, 10) || 0); stopAutoplay(); });
    });
    // Touch handling with axis-lock so a mostly-horizontal swipe doesn't get
    // hijacked by vertical page scroll on iOS Safari.
    var startX = null, startY = null, locked = null;
    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      locked = null;
      stopAutoplay();
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      if (startX === null) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      if (locked === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {
        locked = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }
      if (locked === 'x' && e.cancelable) e.preventDefault();
    }, { passive: false });
    track.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      var sliderW = root.offsetWidth || 1;
      var threshold = Math.max(30, sliderW * 0.12);
      if (locked === 'x') {
        if (dx > threshold) go(index - 1);
        else if (dx < -threshold) go(index + 1);
      }
      startX = null; startY = null; locked = null;
    });
    // Only re-arm autoplay on mouseleave for pointing devices (avoids touch
    // devices restarting autoplay immediately after a tap).
    var hasHover = (window.matchMedia && window.matchMedia('(hover: hover)').matches);
    if (hasHover) {
      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
    }
    // Re-apply transform on resize / orientation / parent reflow so the
    // visible slide stays aligned after any layout width change.
    var rs;
    function onResize() { clearTimeout(rs); rs = setTimeout(function () { go(index); }, 80); }
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('orientationchange', function () { setTimeout(function () { go(index); }, 200); }, { passive: true });
    if (window.ResizeObserver) {
      try { new ResizeObserver(onResize).observe(root); } catch (e) {}
    }
    // Pause autoplay when offscreen or tab hidden.
    if (window.IntersectionObserver) {
      try {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { en.isIntersecting ? startAutoplay() : stopAutoplay(); });
        }, { threshold: 0.4 }).observe(root);
      } catch (e) {}
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAutoplay(); else startAutoplay();
    });
    // Establish initial transform deterministically.
    go(0);
    startAutoplay();
  }
  document.querySelectorAll('[data-carousel]').forEach(hlInitCarousel);
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelectorAll) {
      e.target.querySelectorAll('[data-carousel]').forEach(hlInitCarousel);
    }
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.querySelectorAll) {
      e.target.querySelectorAll('[data-carousel]').forEach(function (r) {
        if (typeof r._hlStop === 'function') r._hlStop();
        r.dataset.ready = '';
      });
    }
  });

  // Thumbnail click → swap main image
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('.hl-pdp__gallery');
    if (!gallery) return;
    var mainImg = gallery.querySelector('[data-main-image] img');
    if (mainImg) {
      // Cancel any pending variant-swap fade so it can't stomp this click.
      if (mainImg._hlSwapT) { clearTimeout(mainImg._hlSwapT); mainImg._hlSwapT = null; }
      mainImg.style.opacity = '';
      mainImg.src = thumb.dataset.imageUrl;
      mainImg.removeAttribute('srcset');
    }
    gallery.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  // Thumb strip prev/next arrows — scroll the strip by ~80% of its width
  // (or height when thumbs are in a vertical column).
  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-thumb-prev]');
    var next = e.target.closest('[data-thumb-next]');
    if (!prev && !next) return;
    var wrap = (prev || next).closest('.hl-pdp__thumbs-wrap');
    var strip = wrap && wrap.querySelector('[data-thumbs]');
    if (!strip) return;
    var isVertical = window.getComputedStyle(strip).flexDirection === 'column';
    if (isVertical) {
      var dy = Math.round(strip.clientHeight * 0.8);
      strip.scrollBy({ top: prev ? -dy : dy, behavior: 'smooth' });
    } else {
      var dx = Math.round(strip.clientWidth * 0.8);
      strip.scrollBy({ left: prev ? -dx : dx, behavior: 'smooth' });
    }
  });

  // Disable thumb arrows when at the start / end (works for horizontal & vertical).
  function syncThumbArrows() {
    document.querySelectorAll('.hl-pdp__thumbs-wrap').forEach(function (wrap) {
      var strip = wrap.querySelector('[data-thumbs]');
      var prev = wrap.querySelector('[data-thumb-prev]');
      var next = wrap.querySelector('[data-thumb-next]');
      if (!strip || !prev || !next) return;
      var isVertical = window.getComputedStyle(strip).flexDirection === 'column';
      var atStart, atEnd;
      if (isVertical) {
        atStart = strip.scrollTop <= 1;
        atEnd = strip.scrollTop + strip.clientHeight >= strip.scrollHeight - 1;
      } else {
        atStart = strip.scrollLeft <= 1;
        atEnd = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 1;
      }
      prev.disabled = atStart;
      next.disabled = atEnd;
    });
  }
  document.querySelectorAll('[data-thumbs]').forEach(function (s) {
    s.addEventListener('scroll', syncThumbArrows, { passive: true });
    // Re-sync when each thumb image finishes loading so scrollWidth is accurate.
    s.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', syncThumbArrows, { once: true, passive: true });
    });
    // Catch parent reflow / orientation / font load that doesn't fire window resize.
    if (window.ResizeObserver) {
      try { new ResizeObserver(syncThumbArrows).observe(s); } catch (e) {}
    }
  });
  // Defer initial measurement until images settle so scrollWidth is real.
  if (document.readyState === 'complete') syncThumbArrows();
  else window.addEventListener('load', syncThumbArrows);
  syncThumbArrows();
  var _hlSyncRaf;
  window.addEventListener('resize', function () {
    cancelAnimationFrame(_hlSyncRaf);
    _hlSyncRaf = requestAnimationFrame(syncThumbArrows);
  }, { passive: true });

  // Quantity stepper
  document.addEventListener('click', function (e) {
    var dec = e.target.closest('[data-qty-dec]');
    var inc = e.target.closest('[data-qty-inc]');
    if (!dec && !inc) return;
    var input = (dec || inc).closest('.hl-pdp__qty-stepper').querySelector('input');
    if (!input) return;
    var n = parseInt(input.value, 10) || 1;
    if (dec) input.value = Math.max(1, n - 1);
    if (inc) input.value = Math.min(99, n + 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Variant picker (color swatches, size buttons, dropdowns, radios)
  function initPicker(scope) {
    scope = scope || document;
    (scope.querySelectorAll ? scope.querySelectorAll('.hl-pdp__variants') : []).forEach(function (root) {
      if (root.dataset.hlPickerInit === '1') return;
      var form = root.closest('form');
      if (!form) return;
      root.dataset.hlPickerInit = '1';
      var idInput = form.querySelector('[data-variant-id]');
      var dataEl = form.querySelector('.hl-product-variants');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var addBtn = form.querySelector('[name="add"]');
      var addLabels = addBtn ? addBtn.querySelectorAll('[data-add-label]') : [];
      var addPrefix = (addBtn && addBtn.dataset.defaultLabel) || 'Add to cart';
      var soldOut = (addBtn && addBtn.dataset.soldOutLabel) || 'Sold out';
      var parent = form.parentElement || form;
      var priceEls = parent.querySelectorAll('[data-product-price]');
      var klarnaEls = parent.querySelectorAll('[data-klarna-line]');
      var buyBtns = parent.querySelectorAll('[data-buy-now]');
      var buyWraps = parent.querySelectorAll('[data-buy-now-wrap]');
      var paymentBtns = parent.querySelectorAll('.shopify-payment-button');

      var selected = [];
      root.querySelectorAll('[data-option-position]').forEach(function (b) {
        var pos = parseInt(b.dataset.optionPosition, 10);
        if (b.tagName === 'SELECT') selected[pos] = b.value;
        else if (b.classList.contains('is-active')) selected[pos] = b.dataset.optionValue;
      });

      function findVariant() {
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return selected[i] === o; });
        });
      }
      function update() {
        var match = findVariant();
        if (!match) return;
        if (idInput) idInput.value = match.id;
        if (priceEls.length) {
          priceEls.forEach(function (priceEl) {
            priceEl.innerHTML = match.compare_at_price > match.price
              ? '<span class="hl-pdp__price-sale">' + match.price_formatted + '</span> <span class="hl-pdp__price-compare">' + match.compare_at_price_formatted + '</span>'
              : match.price_formatted;
          });
        }
        if (klarnaEls.length) {
          klarnaEls.forEach(function (klarna) {
            var tpl = klarna.dataset.klarnaTemplate || klarna.textContent;
            var inst = (match.price / 4 / 100).toFixed(2).replace(/\.00$/, '');
            var sym = (match.price_formatted.match(/^([^\d-]+)/) || [''])[1];
            klarna.textContent = tpl.replace('[amount]', sym + inst);
          });
        }
        if (addBtn) {
          addBtn.disabled = !match.available;
          var label = match.available ? addPrefix : soldOut;
          if (match.available && addBtn.dataset.showPrice === 'true') {
            label += ' — ' + match.price_formatted;
          }
          addLabels.forEach(function (l) { l.textContent = label; });
        }
        if (buyBtns.length) {
          buyBtns.forEach(function (buyBtn) {
            buyBtn.classList.toggle('is-hidden', !match.available);
          });
        }
        if (buyWraps.length) {
          buyWraps.forEach(function (w) { w.classList.toggle('is-hidden', !match.available); });
        }
        if (paymentBtns.length) {
          paymentBtns.forEach(function (p) { p.classList.toggle('is-hidden', !match.available); });
        }

        // Sticky ATC sync
        var stickyPrice = root.querySelector('[data-sticky-price]');
        var stickyVariant = root.querySelector('[data-sticky-variant]');
        var stickyLabel = root.querySelector('[data-sticky-label]');
        var stickyImg = root.querySelector('[data-sticky-img]');
        var stickyAdd = root.querySelector('[data-pdp-sticky-add]');
        // Sticky bar lives outside the variant root — also look in section
        var sectionScope = form.closest('[id^="shopify-section-"]') || document;
        if (!stickyPrice) stickyPrice = sectionScope.querySelector('[data-sticky-price]');
        if (!stickyVariant) stickyVariant = sectionScope.querySelector('[data-sticky-variant]');
        if (!stickyLabel) stickyLabel = sectionScope.querySelector('[data-sticky-label]');
        if (!stickyImg) stickyImg = sectionScope.querySelector('[data-sticky-img]');
        if (!stickyAdd) stickyAdd = sectionScope.querySelector('[data-pdp-sticky-add]');
        if (stickyPrice) stickyPrice.innerHTML = match.price_formatted;
        if (stickyVariant && match.title) stickyVariant.textContent = match.title;
        if (stickyLabel) stickyLabel.textContent = match.available ? (addBtn && addBtn.dataset.defaultLabel || 'Add to bag') : (addBtn && addBtn.dataset.soldOutLabel || 'Sold out');
        if (stickyImg && match.featured_image && match.featured_image.src) stickyImg.src = match.featured_image.src;
        if (stickyAdd) stickyAdd.disabled = !match.available;

        // Swap the gallery image to the variant's featured image (if it has one
        // and only when the source URL would actually change).
        if (match.featured_image) {
          var pdpRoot = form.closest('.hl-pdp') || document;

          function swapImg(imgEl) {
            if (!imgEl) return;
            // Strip Shopify's query string so we can compare base URLs cleanly
            var newSrc = match.featured_image;
            var current = imgEl.getAttribute('src') || '';
            var currentBase = current.split('?')[0].split('.').slice(0, -1).join('.');
            var newBase = newSrc.split('?')[0].split('.').slice(0, -1).join('.');
            if (currentBase === newBase) return;
            // Cancel any prior pending swap so back-to-back variant clicks don't race.
            if (imgEl._hlSwapT) { clearTimeout(imgEl._hlSwapT); imgEl._hlSwapT = null; }
            imgEl.style.opacity = '0';
            imgEl._hlSwapT = setTimeout(function () {
              imgEl.src = newSrc;
              // Only strip srcset if the new URL doesn't carry a matching width
              // descriptor — for now we always strip so the variant featured
              // image is shown 1:1; the browser will still scale via CSS.
              if (imgEl.hasAttribute('srcset')) imgEl.removeAttribute('srcset');
              if (match.featured_image_alt) imgEl.alt = match.featured_image_alt;
              imgEl.style.opacity = '';
              imgEl._hlSwapT = null;
            }, 120);
          }

          // Helper: strip query + extension so URL bases compare reliably
          // regardless of width/format query params.
          function imgBase(s) {
            return (s || '').split('?')[0].split('.').slice(0, -1).join('.');
          }
          var targetBase = imgBase(match.featured_image);

          // 1. Main image in thumbs layout
          var mainImg = pdpRoot.querySelector('[data-main-image] img');
          if (mainImg) swapImg(mainImg);

          // 2. Desktop carousel (transform-based): call the carousel's
          //    public go() so the matching slide actually shows. If no slide
          //    matches (variant has a master-only featured image), fall back
          //    to swapping the currently-visible slide's <img src>.
          var carousel = pdpRoot.querySelector('[data-carousel]');
          if (carousel && typeof carousel._hlGoTo === 'function') {
            var carSlides = carousel.querySelectorAll('.hl-pdp__slide img');
            var matchedSlide = false;
            for (var ci = 0; ci < carSlides.length; ci++) {
              if (imgBase(carSlides[ci].getAttribute('src')) === targetBase) {
                carousel._hlGoTo(ci);
                matchedSlide = true;
                break;
              }
            }
            if (!matchedSlide && carSlides.length) {
              // Find the slide currently in view (first .hl-pdp__slide whose
              // parent track transform matches its index, or just slide 0).
              var visible = carousel.querySelector('.hl-pdp__slide img');
              if (visible) swapImg(visible);
            }
          }

          // 3. Grid / stacked gallery — these may be scrollable horizontally
          //    on mobile (hl-pdp--m-gallery-carousel). Scroll the gallery
          //    container to the matching image so the user actually sees the
          //    variant. Falls through harmlessly on desktop where overflow
          //    is visible (scrollLeft has no effect).
          var galleries = pdpRoot.querySelectorAll('.hl-pdp__gallery--grid, .hl-pdp__gallery--stacked');
          galleries.forEach(function (gal) {
            var imgs = gal.querySelectorAll('.hl-pdp__img');
            for (var gi = 0; gi < imgs.length; gi++) {
              var im = imgs[gi].querySelector('img');
              if (!im) continue;
              if (imgBase(im.getAttribute('src')) === targetBase) {
                // Horizontal: mobile scroll-snap row
                if (gal.scrollWidth > gal.clientWidth + 2) {
                  try { gal.scrollTo({ left: imgs[gi].offsetLeft, behavior: 'smooth' }); }
                  catch (e) { gal.scrollLeft = imgs[gi].offsetLeft; }
                }
                // Vertical: mobile stacked scroll into view
                else if (gal.scrollHeight > gal.clientHeight + 2) {
                  try { gal.scrollTo({ top: imgs[gi].offsetTop, behavior: 'smooth' }); }
                  catch (e) { gal.scrollTop = imgs[gi].offsetTop; }
                }
                break;
              }
            }
          });

          // 4. Mark the matching thumbnail as active (if a thumbnail strip exists)
          var thumbStrip = pdpRoot.querySelector('[data-thumbs]');
          if (thumbStrip) {
            var thumbs = thumbStrip.querySelectorAll('[data-thumb]');
            thumbs.forEach(function (t) {
              t.classList.toggle('is-active', imgBase(t.getAttribute('data-image-url')) === targetBase);
            });
          }
        }

        try {
          var url = new URL(window.location);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url);
        } catch (e) {}
      }

      root.querySelectorAll('[data-option-position]').forEach(function (el) {
        var ev = (el.tagName === 'SELECT') ? 'change' : 'click';
        el.addEventListener(ev, function (e) {
          if (ev === 'click') e.preventDefault();
          var pos = parseInt(el.dataset.optionPosition, 10);
          var val = el.tagName === 'SELECT' ? el.value : el.dataset.optionValue;
          selected[pos] = val;
          root.querySelectorAll('[data-option-position="' + pos + '"]').forEach(function (b) {
            b.classList.toggle('is-active', b.dataset.optionValue === val);
          });
          var labelEl = root.querySelector('[data-option-label="' + pos + '"]');
          if (labelEl) labelEl.textContent = val;
          update();
        });
      });
    });

    // Buy now binding — scoped to incoming scope, with double-bind guard.
    (scope.querySelectorAll ? scope.querySelectorAll('[data-buy-now]') : []).forEach(function (btn) {
      if (btn.dataset.hlBuyNowInit === '1') return;
      btn.dataset.hlBuyNowInit = '1';
      btn.addEventListener('click', function () {
        var form = btn.closest('form');
        if (!form) { window.location.href = '/checkout'; return; }
        var label = btn.querySelector('span');
        var orig = (label && label.textContent) || btn.textContent;
        btn.disabled = true;
        if (label) label.textContent = btn.getAttribute('data-checkout-label') || 'Going to checkout…';
        fetch('/cart/add.js', {
          method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' }
        }).then(function (r) {
          if (r.ok) { window.location.href = '/checkout'; return; }
          return r.json().then(function (err) {
            btn.disabled = false; if (label) label.textContent = orig;
            alert(err.description || btn.getAttribute('data-error-cart') || 'Could not add to cart.');
          });
        }).catch(function () {
          btn.disabled = false;
          if (label) label.textContent = orig;
          var existing = btn.parentNode.querySelector('.hl-pdp__error');
          if (!existing) {
            var msg = document.createElement('p');
            msg.className = 'hl-pdp__error';
            msg.setAttribute('role', 'alert');
            msg.textContent = 'Could not start checkout. Please try again.';
            btn.insertAdjacentElement('afterend', msg);
            setTimeout(function(){ if (msg.parentNode) msg.parentNode.removeChild(msg); }, 4000);
          }
        });
      });
    });
  }
  initPicker(document);
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-product-form], .hl-pdp__variants, [data-buy-now]')) {
      initPicker(e.target);
    }
  });

  // Wishlist — toggle product handle in localStorage. Heart fills when saved.
  (function () {
    var KEY = 'hl-wishlist';
    function read() {
      try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
    }
    function write(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
      window.dispatchEvent(new CustomEvent('hl-wishlist:change', { detail: list }));
    }
    function syncHearts() {
      var list = read();
      document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
        var saved = list.indexOf(btn.dataset.wishlistToggle) !== -1;
        btn.classList.toggle('is-saved', saved);
        var icon = btn.querySelector('i');
        if (icon) icon.className = saved ? 'ti ti-heart' : 'ti ti-heart';
        btn.setAttribute('aria-label', saved ? (btn.getAttribute('data-label-remove') || 'Remove from wishlist') : (btn.getAttribute('data-label-save') || 'Save to wishlist'));
      });
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      var handle = btn.dataset.wishlistToggle;
      var list = read();
      var i = list.indexOf(handle);
      if (i === -1) list.push(handle); else list.splice(i, 1);
      write(list);
      syncHearts();
    });
    syncHearts();
    window.addEventListener('hl-wishlist:change', syncHearts);
  })();

  // Share — copy link
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-share-copy]');
    if (!btn) return;
    e.preventDefault();
    var url = btn.dataset.shareUrl || window.location.href;
    if (navigator.clipboard) navigator.clipboard.writeText(url);
    var icon = btn.querySelector('i');
    if (icon) {
      var prev = icon.className;
      icon.className = 'ti ti-check';
      setTimeout(function () { icon.className = prev; }, 1500);
    }
  });

  // === AJAX Add-to-cart ===
  // Intercepts the product form submit so adding a product opens the cart
  // drawer instead of navigating to /cart. Falls back to native form submit
  // if AJAX fails so customers can always check out.
  document.querySelectorAll('form[action$="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      // Allow if this is a buy-now flow (handled separately)
      if (form.dataset.bypassAjax === '1') return;
      e.preventDefault();
      var atc = form.querySelector('button[type="submit"][name="add"]');
      var label = atc && atc.querySelector('[data-add-label]');
      var origText = label && label.textContent;
      if (atc) atc.disabled = true;
      if (label) label.textContent = (atc && atc.getAttribute('data-adding-label')) || 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (err) { throw new Error(err.description || err.message || 'Add failed'); });
        }
        return r.json();
      })
      .then(function () {
        // Refresh cart drawer + header bag count, then open the drawer.
        var refresh = window.__hlRefreshCartSections;
        var done = refresh ? refresh() : Promise.resolve();
        return done.then(function () {
          var d = document.getElementById('cart-drawer');
          if (d) {
            d.classList.add('open');
            d.setAttribute('aria-hidden', 'false');
            document.body.classList.add('cart-drawer-open');
          }
        });
      })
      .catch(function (err) {
        // Show error inline if possible; else fallback to native form submit
        if (label) label.textContent = origText || (atc && atc.getAttribute('data-default-label')) || 'Add to cart';
        if (atc) atc.disabled = false;
        console.error('[Hemline ATC]', err);
        // Last-resort fallback so the customer can still check out
        form.dataset.bypassAjax = '1';
        form.submit();
      })
      .finally(function () {
        setTimeout(function () {
          if (label && label.textContent === 'Adding…') label.textContent = origText || 'Add to cart';
          if (atc) atc.disabled = false;
        }, 400);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Lazy-fetch recommendations from Shopify's product_recommendations endpoint.
    // Shopify can't return personalized recommendations during the initial
    // server render — they're computed asynchronously, so we fetch them after
    // the section is in the DOM and swap in the real grid.
    function fetchRecs(root) {
      var url = root.getAttribute('data-url');
      if (!url) return;
      fetch(url)
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('.hl-recs__grid');
          var oldGrid = root.querySelector('.hl-recs__grid');
          if (newGrid && oldGrid) {
            // Only swap if the fetched grid actually has real product cells
            // (otherwise we'd just be replacing placeholders with placeholders).
            var newCells = Array.prototype.filter.call(newGrid.querySelectorAll('.hl-recs__cell'), function (cell) { return !cell.querySelector('.hl-recs__ph-img'); });
            if (newCells.length > 0) {
              oldGrid.innerHTML = newGrid.innerHTML;
              // Re-observe any new reveal targets
              root.dispatchEvent(new CustomEvent('hl:recs-loaded', { bubbles: true }));
            }
          }
        })
        .catch(function () { /* silently fall back to placeholders */ });
    }

    document.querySelectorAll('[data-hl-recs]').forEach(fetchRecs);

    // Reveal-on-scroll for placeholder + fetched cards
    if (!('IntersectionObserver' in window)) return;
    var recs = document.querySelectorAll('.hl-recs');
    if (!recs.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    function observe(root) {
      root.querySelectorAll('.hl-reveal').forEach(function (c) { io.observe(c); });
    }
    recs.forEach(observe);
    document.addEventListener('hl:recs-loaded', function (e) { observe(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.hl-reviews').forEach(function (root) {
      /* Star-filter on the breakdown */
      var items = root.querySelectorAll('[data-hl-rv-item]');
      root.querySelectorAll('[data-hl-rv-filter]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var n = btn.getAttribute('data-hl-rv-filter');
          var active = btn.classList.contains('is-active');
          root.querySelectorAll('[data-hl-rv-filter].is-active').forEach(function (b) { b.classList.remove('is-active'); });
          if (active) {
            items.forEach(function (i) { i.style.display = ''; });
          } else {
            btn.classList.add('is-active');
            items.forEach(function (i) {
              i.style.display = (i.getAttribute('data-hl-rv-rating') === n) ? '' : 'none';
            });
          }
        });
      });

      /* Show more — bumps max from 8 to all */
      var moreBtn = root.querySelector('[data-hl-rv-more]');
      if (moreBtn) {
        moreBtn.addEventListener('click', function () {
          /* Re-fetch the section as full and replace — best-effort progressive enhancement.
             If fetch fails, just hide button (existing items still visible). */
          var url = window.location.pathname + '?section_id=' + encodeURIComponent(root.closest('[id^="shopify-section-"]').id.replace('shopify-section-', '')) + '&show_all=1';
          /* Fallback simple approach: just unhide everything (server-rendered ones beyond the limit aren't here, so this just toggles button off). */
          moreBtn.style.display = 'none';
        });
      }
    });

    /* === Review submission modal === */
    document.querySelectorAll('[data-hl-rv-open-form]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var modal = document.querySelector('[data-hl-rv-modal]');
        if (!modal) return;
        modal.removeAttribute('hidden');
        modal.offsetHeight;
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    });
    function closeRvModal() {
      var modal = document.querySelector('[data-hl-rv-modal]');
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setTimeout(function () { modal.setAttribute('hidden', ''); }, 300);
    }
    document.querySelectorAll('[data-hl-rv-close]').forEach(function (el) {
      el.addEventListener('click', closeRvModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var m = document.querySelector('[data-hl-rv-modal].is-open');
        if (m) closeRvModal();
      }
    });

    /* Interactive star picker */
    document.querySelectorAll('.hl-rv-form').forEach(function (form) {
      var stars = form.querySelectorAll('[data-hl-rv-star]');
      var input = form.querySelector('[data-hl-rv-rating-value]');
      var current = 0;
      function paint(n) {
        stars.forEach(function (s, idx) {
          var on = (idx + 1) <= n;
          s.classList.toggle('is-on', on);
          s.setAttribute('aria-checked', on ? 'true' : 'false');
          var icon = s.querySelector('i');
          if (icon) icon.className = on ? 'ti ti-star-filled' : 'ti ti-star';
        });
      }
      stars.forEach(function (s) {
        s.addEventListener('mouseenter', function () { paint(parseInt(s.getAttribute('data-hl-rv-star'), 10)); });
        s.addEventListener('mouseleave', function () { paint(current); });
        s.addEventListener('click', function () {
          current = parseInt(s.getAttribute('data-hl-rv-star'), 10);
          if (input) input.value = current;
          paint(current);
        });
      });

      /* AJAX submit */
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var feedback = form.querySelector('[data-hl-rv-feedback]');
        var successPanel = form.parentElement.querySelector('[data-hl-rv-success]');
        var btn = form.querySelector('[data-hl-rv-submit]');
        var label = form.querySelector('[data-hl-rv-submit-label]');
        var origLabel = label ? label.textContent : '';

        if (!input || !input.value) {
          if (feedback) {
            feedback.hidden = false;
            feedback.textContent = form.getAttribute('data-error-no-rating') || 'Please pick a star rating before submitting.';
            feedback.className = 'hl-rv-form__feedback is-error';
          }
          return;
        }

        if (btn) btn.disabled = true;
        if (label) label.textContent = form.getAttribute('data-sending-label') || 'Sending…';
        if (feedback) { feedback.hidden = true; feedback.textContent = ''; feedback.className = 'hl-rv-form__feedback'; }

        var action = form.getAttribute('action') || (window.location.pathname + '?form_type=contact');
        fetch(action, {
          method: 'POST',
          body: new FormData(form),
          headers: { 'Accept': 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin',
          redirect: 'follow'
        })
          .then(function (r) { return r.text().then(function (t) { return { ok: r.ok, text: t }; }); })
          .then(function (res) {
            var hasError =
              /Email\s+(is|has\s+already|cannot|must)\b/i.test(res.text) ||
              /Please\s+enter\s+a\s+valid\s+email/i.test(res.text) ||
              /Could not/i.test(res.text);
            if (res.ok && !hasError) {
              form.hidden = true;
              if (successPanel) successPanel.hidden = false;
            } else if (feedback) {
              feedback.hidden = false;
              feedback.textContent = hasError ? (form.getAttribute('data-error-invalid-email') || 'That email looks off. Please double-check and resubmit.') : (form.getAttribute('data-error-generic') || 'Something went wrong. Please try again.');
              feedback.className = 'hl-rv-form__feedback is-error';
            }
          })
          .catch(function () {
            if (feedback) {
              feedback.hidden = false;
              feedback.textContent = form.getAttribute('data-error-network') || 'Network error. Please try again.';
              feedback.className = 'hl-rv-form__feedback is-error';
            }
          })
          .finally(function () {
            if (btn) btn.disabled = false;
            if (label) label.textContent = origLabel;
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEY = 'hl-recently-viewed';
    var roots = document.querySelectorAll('[data-hl-recently-viewed]');
    if (!roots.length) return;

    function money(cents) {
      var n = (cents / 100);
      return '$' + n.toFixed(n % 1 === 0 ? 0 : 2);
    }

    roots.forEach(function (root) {
      var grid = root.querySelector('[data-hl-rv-grid]');
      if (!grid) return;
      var max = parseInt(root.getAttribute('data-hl-rv-max'), 10) || 8;
      var current = root.getAttribute('data-hl-rv-current');

      var handles = [];
      try { handles = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
      handles = handles.filter(function (h) { return h && h !== current; }).slice(0, max);
      if (!handles.length) return;

      Promise.all(handles.map(function (h) {
        return fetch('/products/' + h + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })).then(function (items) {
        var html = items.filter(Boolean).map(function (p) {
          var img = (p.featured_image || (p.images && p.images[0]) || '');
          var img2 = (p.images && p.images[1]) || '';
          return '<a class="hl-rv__card" href="' + p.url + '">' +
            '<div class="hl-rv__card-img">' +
              (img ? '<img loading="lazy" src="' + img + '" width="500" height="625" alt="' + (p.title || '').replace(/"/g, '&quot;') + '">' : '') +
            '</div>' +
            '<div class="hl-rv__card-meta">' +
              '<div class="mid">' + (p.title || '') + '</div>' +
              '<div class="hl-rv__card-price">' + money(p.price) + '</div>' +
            '</div>' +
          '</a>';
        }).join('');
        if (!html) return;
        grid.innerHTML = html;
        root.removeAttribute('hidden');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var roots = document.querySelectorAll('.hl-search');
    if (!roots.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    roots.forEach(function (r) { r.querySelectorAll('.hl-reveal').forEach(function (c) { io.observe(c); }); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  // Hemline slideshow — simple opacity crossfade. Carousel mechanics
  // (auto-rotate, dots, arrows, swipe) run in both overlay and stacked
  // mobile modes — only the per-slide layout differs (text-on-image vs
  // text-below-image), which is handled entirely in CSS.
  (function () {
    function init(root) {
      if (root._hlSSInit) return;
      root._hlSSInit = true;

      var slides = root.querySelectorAll('.hl-slideshow__slide');
      var dots = root.querySelectorAll('.hl-slideshow__dot');
      var countEl = root.querySelector('[data-count-current]');
      var count = slides.length;
      if (count < 2) {
        if (slides[0]) slides[0].classList.add('is-active');
        return;
      }

      var current = 0;

      function pad(n) { return n < 10 ? '0' + n : String(n); }

      function show(i) {
        if (i < 0) i = count - 1;
        if (i >= count) i = 0;
        for (var s = 0; s < slides.length; s++) {
          slides[s].classList.toggle('is-active', s === i);
        }
        // For 'bars' style: is-past for past slides, is-active for current.
        // Toggling classes also restarts the CSS fill animation for the active one.
        for (var d = 0; d < dots.length; d++) {
          var dot = dots[d];
          dot.classList.toggle('is-active', d === i);
          dot.classList.toggle('is-past', d < i);
          dot.setAttribute('aria-selected', d === i ? 'true' : 'false');
        }
        // For 'count' style: update the displayed current slide number.
        if (countEl) countEl.textContent = pad(i + 1);
        current = i;
      }

      show(0);

      for (var dd = 0; dd < dots.length; dd++) {
        (function (idx) {
          dots[idx].addEventListener('click', function () { show(idx); });
        })(dd);
      }

      var prevBtn = root.querySelector('[data-slide-prev]');
      var nextBtn = root.querySelector('[data-slide-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); });

      var startX = 0, startY = 0, dx = 0, dy = 0, active = false;
      root.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX; startY = e.touches[0].clientY;
        dx = 0; dy = 0; active = true;
      }, { passive: true });
      root.addEventListener('touchmove', function (e) {
        if (!active || e.touches.length !== 1) return;
        dx = e.touches[0].clientX - startX;
        dy = e.touches[0].clientY - startY;
      }, { passive: true });
      root.addEventListener('touchend', function () {
        if (!active) return;
        active = false;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          show(dx < 0 ? current + 1 : current - 1);
        }
      }, { passive: true });

      if (root.hasAttribute('data-autoplay')) {
        var cycleStr = getComputedStyle(root).getPropertyValue('--cycle-seconds');
        var cycle = parseFloat(cycleStr);
        if (isNaN(cycle) || cycle <= 0) cycle = 6;
        var cycleMs = cycle * 1000;

        // Pause-on-hover: only on hover-capable devices. We pause the timer
        // (skip the tick) instead of clearing it so the cadence resumes cleanly.
        // The progress-bar fill animation is also paused via CSS class so it
        // stays in sync with the timer.
        root._hlSSHoverPaused = false;
        if (root.hasAttribute('data-pause-on-hover')
            && window.matchMedia
            && window.matchMedia('(hover: hover)').matches) {
          root.addEventListener('mouseenter', function () {
            root._hlSSHoverPaused = true;
            root.classList.add('is-paused');
          });
          root.addEventListener('mouseleave', function () {
            root._hlSSHoverPaused = false;
            root.classList.remove('is-paused');
          });
        }

        if (!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
          if (root._hlSSTimer) clearInterval(root._hlSSTimer);
          root._hlSSTimer = setInterval(function () {
            if (document.hidden) return;
            if (root._hlSSHoverPaused) return;
            show(current + 1);
          }, cycleMs);
        }
      }

      root.setAttribute('tabindex', root.getAttribute('tabindex') || '0');
      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); show(current + 1); }
        if (e.key === 'ArrowLeft')  { e.preventDefault(); show(current - 1); }
      });

      root._hlSSShow = show;
    }

    function initAll() {
      var nodes = document.querySelectorAll('.hl-slideshow');
      for (var i = 0; i < nodes.length; i++) init(nodes[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (!e.target || !e.target.querySelectorAll) return;
      var roots = e.target.querySelectorAll('.hl-slideshow');
      for (var i = 0; i < roots.length; i++) {
        roots[i]._hlSSInit = false;
        init(roots[i]);
      }
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var r = e.target && e.target.querySelector ? e.target.querySelector('.hl-slideshow') : null;
      if (r && r._hlSSTimer) { clearInterval(r._hlSSTimer); r._hlSSTimer = null; }
    });

    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target && e.target.closest ? e.target.closest('.hl-slideshow') : null;
      if (!root) return;
      var slides = root.querySelectorAll('.hl-slideshow__slide');
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-block-id') === e.detail.blockId) {
          if (typeof root._hlSSShow === 'function') root._hlSSShow(i);
          break;
        }
      }
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  // Auto-loop carousel: scroll by one card every <cycle>s. When the end is
  // reached, snap back to the start. Pauses on hover. Honours reduced-motion.
  (function () {
    function initLoop(root) {
      var track = root.querySelector('.hl-tst__grid--carousel[data-hl-tst-autoplay]');
      if (!track) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var cycle = parseFloat(track.getAttribute('data-hl-tst-cycle')) || 5;
      var paused = false;
      track.addEventListener('mouseenter', function () { paused = true; });
      track.addEventListener('mouseleave', function () { paused = false; });
      track.addEventListener('touchstart', function () { paused = true; }, { passive: true });

      var iv = setInterval(function () {
        if (!document.contains(track)) { clearInterval(iv); return; }
        if (paused || document.hidden) return;
        var first = track.firstElementChild;
        if (!first) return;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        var step = first.offsetWidth + gap;
        var atEnd = (track.scrollLeft + track.clientWidth) >= (track.scrollWidth - 4);
        if (atEnd) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: step, behavior: 'smooth' });
        }
      }, cycle * 1000);
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.hl-tst').forEach(initLoop);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topbar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-hl-topbar-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var bar = btn.closest('.hl-topbar');
        if (!bar) return;
        bar.classList.add('is-dismissed');
        try { sessionStorage.setItem('hl-topbar-dismissed', '1'); } catch (e) {}
      });
    });
    try {
      if (sessionStorage.getItem('hl-topbar-dismissed') === '1') {
        document.querySelectorAll('.hl-topbar [data-hl-topbar-close]').forEach(function (btn) {
          var bar = btn.closest('.hl-topbar');
          if (bar) bar.classList.add('is-dismissed');
        });
      }
    } catch (e) {}
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trustpilot-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTpSlider(root) {
      if (!root || root.dataset.hlTpInit === '1') return;
      if (!root.classList.contains('hl-tp--layout-slider')) return;
      var track = root.querySelector('[data-hl-tp-track]');
      if (!track) return;
      var loop = root.getAttribute('data-hl-tp-loop') !== 'false';
      function slides() {
        return Array.prototype.filter.call(track.children, function (el) {
          return el.nodeType === 1 && el.classList.contains('hl-tp__card');
        });
      }
      if (slides().length < 2) return;
      function w() { var s = slides(); return s[0] ? s[0].getBoundingClientRect().width : track.clientWidth; }
      function current() { var sw = w(); return sw ? Math.round(track.scrollLeft / sw) : 0; }
      function update(i) {
        root.querySelectorAll('[data-hl-tp-dot]').forEach(function (d, idx) {
          d.classList.toggle('is-active', idx === i);
        });
      }
      function go(i) {
        var n = slides().length;
        if (n < 1) return;
        if (i < 0) i = loop ? n - 1 : 0;
        if (i >= n) i = loop ? 0 : n - 1;
        var sw = w();
        if (track.scrollTo) track.scrollTo({ left: i * sw, behavior: 'smooth' });
        else track.scrollLeft = i * sw;
        update(i);
      }
      root.addEventListener('click', function (e) {
        var dot = e.target.closest('[data-hl-tp-dot]');
        if (dot) { go(parseInt(dot.getAttribute('data-hl-tp-dot'), 10) || 0); return; }
        if (e.target.closest('[data-hl-tp-prev]')) { go(current() - 1); return; }
        if (e.target.closest('[data-hl-tp-next]')) { go(current() + 1); return; }
      });
      track.addEventListener('scroll', function () { update(current()); }, { passive: true });

      // Autoplay
      var autoplay = root.hasAttribute('data-hl-tp-autoplay');
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (autoplay && !reduced) {
        var cycle = parseFloat(getComputedStyle(root).getPropertyValue('--slide-cycle')) || 6;
        var paused = false;
        ['mouseenter', 'focusin'].forEach(function (e) { root.addEventListener(e, function () { paused = true; }); });
        ['mouseleave', 'focusout'].forEach(function (e) { root.addEventListener(e, function () { paused = false; }); });
        var iv = setInterval(function () {
          if (paused) return;
          if (!document.contains(root)) { clearInterval(iv); return; }
          go(current() + 1);
        }, cycle * 1000);
      }

      update(0);
      root.dataset.hlTpInit = '1';
    }
    function initAll(scope) {
      (scope || document).querySelectorAll('.hl-tp--layout-slider').forEach(initTpSlider);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load',   function (e) { initAll(e.target); });
    document.addEventListener('shopify:section:select', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-hl-vslide]').forEach(function (root) {
      var track = root.querySelector('[data-hl-vslide-track]');
      if (!track) return;
      var slides = root.querySelectorAll('[data-hl-vslide-slide]');
      if (slides.length < 2) return;

      var prev = root.querySelector('[data-hl-vslide-prev]');
      var next = root.querySelector('[data-hl-vslide-next]');
      var dots = root.querySelectorAll('[data-hl-vslide-dot]');
      var counter = root.querySelector('[data-hl-vslide-current]');
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var loop = root.getAttribute('data-loop') === 'true';

      function indexFromScroll() {
        var w = slides[0] ? slides[0].getBoundingClientRect().width : 0;
        var gap = parseFloat(getComputedStyle(track).gap) || 0;
        if (!w) return 0;
        return Math.round(track.scrollLeft / (w + gap));
      }
      function update(i) {
        dots.forEach(function (d, idx) {
          d.classList.toggle('is-active', idx === i);
        });
        if (counter) counter.textContent = String(i + 1);
        if (prev) prev.disabled = !loop && i === 0;
        if (next) next.disabled = !loop && i === slides.length - 1;
      }
      function goTo(i) {
        if (i < 0) i = loop ? slides.length - 1 : 0;
        if (i >= slides.length) i = loop ? 0 : slides.length - 1;
        var w = slides[0].getBoundingClientRect().width;
        var gap = parseFloat(getComputedStyle(track).gap) || 0;
        track.scrollTo({ left: i * (w + gap), behavior: 'smooth' });
        update(i);
      }

      if (prev) prev.addEventListener('click', function () { goTo(indexFromScroll() - 1); });
      if (next) next.addEventListener('click', function () { goTo(indexFromScroll() + 1); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          goTo(parseInt(d.getAttribute('data-hl-vslide-dot'), 10));
        });
      });
      track.addEventListener('scroll', function () { update(indexFromScroll()); });

      update(0);

      // Autoplay-rotate the slides (only when no native video controls are used)
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (autoplay && !reduced) {
        var cycleSec = parseFloat(getComputedStyle(root).getPropertyValue('--cycle')) || 6;
        var paused = false;
        ['mouseenter', 'focusin'].forEach(function (e) { root.addEventListener(e, function () { paused = true; }); });
        ['mouseleave', 'focusout'].forEach(function (e) { root.addEventListener(e, function () { paused = false; }); });
        setInterval(function () {
          if (paused) return;
          goTo(indexFromScroll() + 1);
        }, cycleSec * 1000);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-hl-vtest]').forEach(function (root) {
      var track = root.querySelector('[data-hl-vtest-track]');
      var slides = root.querySelectorAll('[data-hl-vtest-slide]');
      var prevBtn = root.querySelector('[data-hl-vtest-prev]');
      var nextBtn = root.querySelector('[data-hl-vtest-next]');
      var dots = root.querySelectorAll('[data-hl-vtest-dot]');
      var counter = root.querySelector('[data-hl-vtest-current]');
      if (!track || !slides.length) return;

      function activeIndex() {
        var x = track.scrollLeft;
        var best = 0, dist = Infinity;
        slides.forEach(function (s, i) {
          var d = Math.abs(s.offsetLeft - x);
          if (d < dist) { dist = d; best = i; }
        });
        return best;
      }
      function syncNav() {
        var i = activeIndex();
        dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
        if (counter) counter.textContent = (i + 1);
        if (prevBtn) prevBtn.disabled = i === 0;
        if (nextBtn) nextBtn.disabled = i === slides.length - 1;
      }
      function go(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        var s = slides[i];
        if (s) track.scrollTo({ left: s.offsetLeft, behavior: 'smooth' });
      }
      if (prevBtn) prevBtn.addEventListener('click', function () { stopAuto(); go(activeIndex() - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { stopAuto(); go(activeIndex() + 1); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { stopAuto(); go(parseInt(d.getAttribute('data-hl-vtest-dot'), 10) || 0); });
      });
      track.addEventListener('scroll', function () {
        clearTimeout(track._t);
        track._t = setTimeout(syncNav, 80);
      });
      syncNav();

      // ===== Carousel autoplay (merchant-controlled) =====
      var carouselAutoplay = root.getAttribute('data-carousel-autoplay') === 'true';
      var carouselInterval = parseInt(root.getAttribute('data-carousel-interval'), 10) || 5000;
      var carouselPauseHover = root.getAttribute('data-carousel-pause-hover') === 'true';
      var carouselLoop = root.getAttribute('data-carousel-loop') === 'true';
      var autoTimer = null;
      var autoStopped = false;
      function tick() {
        if (autoStopped) return;
        var i = activeIndex();
        var next = i + 1;
        if (next >= slides.length) {
          if (!carouselLoop) { stopAuto(); return; }
          next = 0;
        }
        go(next);
      }
      function startAuto() {
        if (!carouselAutoplay || autoStopped || slides.length <= 1) return;
        if (autoTimer) clearInterval(autoTimer);
        autoTimer = setInterval(tick, carouselInterval);
      }
      function pauseAuto() { if (autoTimer) { clearInterval(autoTimer); autoTimer = null; } }
      function stopAuto() { autoStopped = true; pauseAuto(); }
      if (carouselAutoplay) {
        // Pause when hovered (if enabled), pause when tab is hidden, resume on visible
        if (carouselPauseHover) {
          root.addEventListener('mouseenter', pauseAuto);
          root.addEventListener('mouseleave', function () { if (!autoStopped) startAuto(); });
          root.addEventListener('focusin', pauseAuto);
          root.addEventListener('focusout', function () { if (!autoStopped) startAuto(); });
        }
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) pauseAuto(); else if (!autoStopped) startAuto();
        });
        // Pause if the user starts swiping (touch interaction)
        track.addEventListener('touchstart', stopAuto, { passive: true });
        // Begin rotation
        startAuto();
      }

      /* YouTube / Vimeo: replace poster with embed iframe on click */
      root.querySelectorAll('[data-hl-vtest-embed]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var url = btn.getAttribute('data-hl-vtest-embed');
          var iframe = document.createElement('iframe');
          iframe.className = 'hl-vtest__video';
          iframe.src = url;
          iframe.setAttribute('frameborder', '0');
          iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
          iframe.setAttribute('allowfullscreen', '');
          iframe.setAttribute('title', 'Customer review video');
          btn.replaceWith(iframe);
        });
      });

      /* Autoplay in-view native videos when scrolled to (muted) */
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var v = entry.target.querySelector('video[data-hl-vtest-video]');
            if (!v) return;
            if (entry.isIntersecting && autoplay) v.play().catch(function () {});
            else v.pause();
          });
        }, { threshold: 0.5 });
        slides.forEach(function (s) { io.observe(s); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEY = 'hl-wishlist';

    function read() {
      try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
    }
    function write(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
      // Notify other parts of the page (e.g., header counter, product page heart).
      window.dispatchEvent(new CustomEvent('hl-wishlist:change', { detail: list }));
    }
    function escapeHtml(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function init(scope) {
      var root = scope || document;
      var grid = root.querySelector('[data-wishlist-grid]');
      if (!grid) return;
      // Guard against double-init when both DOMContentLoaded and section:load fire.
      if (grid.__hlWishlistInit) return;
      grid.__hlWishlistInit = true;

      var empty = root.querySelector('[data-wishlist-empty]') || document.querySelector('[data-wishlist-empty]');
      var loading = root.querySelector('[data-wishlist-loading]') || document.querySelector('[data-wishlist-loading]');
      var counter = root.querySelector('[data-wishlist-count]') || document.querySelector('[data-wishlist-count]');
      var removeLabel = grid.getAttribute('data-remove-label') || 'Remove from wishlist';
      var currency = grid.getAttribute('data-currency') || (document.body.dataset && document.body.dataset.cartCurrency) || 'USD';
      var locale = grid.getAttribute('data-locale') || (document.body.dataset && document.body.dataset.locale) || undefined;

      function remove(handle, opts) {
        var list = read().filter(function (h) { return h !== handle; });
        write(list);
        render(opts);
      }

      function formatMoney(cents) {
        try {
          return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
        } catch (e) {
          return '$' + (cents / 100).toFixed(2);
        }
      }

      function focusAfterRemove(prevIndex) {
        var buttons = grid.querySelectorAll('[data-wishlist-remove]');
        if (buttons.length === 0) {
          // Grid empty — fall back to grid itself (tabindex="-1" set in markup).
          if (grid.hasAttribute('tabindex')) {
            try { grid.focus(); } catch (e) {}
          }
          return;
        }
        var nextIdx = typeof prevIndex === 'number' ? Math.min(prevIndex, buttons.length - 1) : 0;
        if (nextIdx < 0) nextIdx = 0;
        try { buttons[nextIdx].focus(); } catch (e) {}
      }

      function render(opts) {
        var handles = read();
        if (counter) counter.textContent = handles.length === 0 ? '' : handles.length + (handles.length === 1 ? ' piece saved' : ' pieces saved');

        if (handles.length === 0) {
          grid.innerHTML = '';
          if (loading) loading.hidden = true;
          if (empty) empty.hidden = false;
          if (opts && opts.restoreFocus) focusAfterRemove(opts.prevIndex);
          return;
        }

        if (empty) empty.hidden = true;
        if (loading) loading.hidden = false;
        grid.innerHTML = '';

        // Fetch each product in parallel via /products/{handle}.js
        var fetches = handles.map(function (handle) {
          return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.json() : null; })
            .catch(function () { return null; });
        });

        Promise.all(fetches).then(function (products) {
          if (loading) loading.hidden = true;
          var html = '';
          products.forEach(function (p, i) {
            if (!p) {
              // Product was removed from store — remove from wishlist silently.
              remove(handles[i]);
              return;
            }
            var img = p.featured_image || (p.images && p.images[0]) || '';
            var price = formatMoney(p.price);
            html += '<div class="hl-wishlist__item">' +
              '<button type="button" class="hl-wishlist__remove" data-wishlist-remove="' + escapeHtml(p.handle) + '" aria-label="' + escapeHtml(removeLabel) + '">' +
                '<i class="ti ti-x" aria-hidden="true"></i>' +
              '</button>' +
              '<a href="' + escapeHtml(p.url) + '" class="hl-wishlist__item-link">' +
                '<div class="hl-wishlist__item-img">' +
                  (img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
                '</div>' +
                '<div class="hl-wishlist__item-meta">' +
                  '<div class="hl-wishlist__item-title">' + escapeHtml(p.title) + '</div>' +
                  '<div class="hl-wishlist__item-price">' + price + '</div>' +
                '</div>' +
              '</a>' +
            '</div>';
          });
          grid.innerHTML = html;
          if (opts && opts.restoreFocus) focusAfterRemove(opts.prevIndex);
        });
      }

      // Remove handler
      grid.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-wishlist-remove]');
        if (!btn) return;
        e.preventDefault();
        // Compute the index of the removed button among siblings so we can
        // restore focus to the next remaining button after re-render.
        var buttons = grid.querySelectorAll('[data-wishlist-remove]');
        var prevIndex = 0;
        for (var i = 0; i < buttons.length; i++) {
          if (buttons[i] === btn) { prevIndex = i; break; }
        }
        remove(btn.dataset.wishlistRemove, { restoreFocus: true, prevIndex: prevIndex });
      });

      render();

      // Listen for cross-section changes (header heart, PDP heart).
      // Re-render uses the same grid — no double-init concern.
      var onChange = function () { render(); };
      window.addEventListener('hl-wishlist:change', onChange);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('[data-wishlist-grid]')) {
        init(e.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
